import React, {
    useCallback,
    useEffect,
    useRef,
    useState
} from "react";

import {
    getConversations,
    getMessages,
    sendMessage,
    markConversationAsRead,
    assignConversation,
    returnToBot,
    closeConversation,
    reopenConversation,
    getDepartments
} from "./services/api";

import {
    useAuth
} from "./context/AuthContext";

import Login from "./pages/Login";

import "./App.css";
import { io } from "socket.io-client";

// ============================================================
// APP
// ============================================================

function App() {

    const {
        operator,
        loading,
        isAuthenticated
    } = useAuth();


    if (loading) {

        return (

            <div className="auth-loading">
                Carregando...
            </div>

        );

    }


    if (!isAuthenticated) {

        return <Login />;

    }


    return (

        <Omnichannel
            operator={operator}
        />

    );

}

// ============================================================
// MESSAGE LIST
// ============================================================

function MessageList({
    message
}) {

    const [
        open,
        setOpen
    ] = useState(false);


    // ========================================================
    // OPÇÃO DE LISTA SELECIONADA
    // ========================================================

    if (
        typeof message === "string" &&
        message.startsWith("[LIST]")
    ) {

        const selectedOption =
            message
                .replace(
                    "[LIST]",
                    ""
                )
                .trim();


        return (

            <div className="message-list-selected">

                <div className="message-list-selected-label">
                    Opção selecionada
                </div>

                <div className="message-list-selected-title">
                    {selectedOption || "Opção não identificada"}
                </div>

            </div>

        );

    }


    // ========================================================
    // LISTA INTERATIVA
    // ========================================================

    let data = null;


    try {

        let value = message;


        if (typeof value === "string") {

            value = value.trim();


            // Remove ** caso a mensagem tenha sido salva assim

            if (
                value.startsWith("**") &&
                value.endsWith("**")
            ) {

                value =
                    value
                        .slice(2, -2)
                        .trim();

            }


            data = JSON.parse(value);

        } else {

            data = value;

        }

    } catch {

        return message;

    }


    if (
        !data ||
        data.type !== "list"
    ) {

        return message;

    }


    return (

        <div className="message-list">

            {
                data.title && (

                    <div className="message-list-title">
                        {data.title}
                    </div>

                )
            }


            {
                data.description && (

                    <div className="message-list-description">
                        {data.description}
                    </div>

                )
            }


            <button
                type="button"
                className="message-list-button"
                onClick={() =>
                    setOpen(
                        previous => !previous
                    )
                }
            >

                <span>
                    {
                        data.buttonText ||
                        "Ver opções"
                    }
                </span>


                <span className="message-list-arrow">
                    {
                        open
                            ? "⌃"
                            : "⌄"
                    }
                </span>

            </button>


            {
                open && (

                    <div className="message-list-options">

                        {
                            Array.isArray(
                                data.sections
                            ) &&
                            data.sections.map(
                                (
                                    section,
                                    sectionIndex
                                ) => (

                                    <div
                                        key={
                                            sectionIndex
                                        }
                                        className="message-list-section"
                                    >

                                        {
                                            section.title && (

                                                <div className="message-list-section-title">
                                                    {
                                                        section.title
                                                    }
                                                </div>

                                            )
                                        }


                                        {
                                            Array.isArray(
                                                section.rows
                                            ) &&
                                            section.rows.map(
                                                (
                                                    row,
                                                    rowIndex
                                                ) => (

                                                    <div
                                                        key={
                                                            row.rowId ||
                                                            rowIndex
                                                        }
                                                        className="message-list-option"
                                                    >

                                                        {
                                                            row.title
                                                        }

                                                    </div>

                                                )
                                            )
                                        }

                                    </div>

                                )
                            )
                        }

                    </div>

                )
            }

        </div>

    );

}

// ============================================================
// OMNICHANNEL
// ============================================================

function Omnichannel({
    operator
}) {

    const {
        logout
    } = useAuth();

    // ========================================================
    // FILTROS
    // ========================================================

    const [
        mode,
        setMode
    ] = useState("");

    const [
        status,
        setStatus
    ] = useState("OPEN");

    const [
        state,
        setState
    ] = useState("");

    const [
        departmentId,
        setDepartmentId
    ] = useState("");

    const [
        departments,
        setDepartments
    ] = useState([]);

    // ========================================================
    // CONVERSAS
    // ========================================================

    const [
        conversations,
        setConversations
    ] = useState([]);

    const [
        selectedConversation,
        setSelectedConversation
    ] = useState(null);


    // ========================================================
    // MOBILE
    // ========================================================

    const [
        mobileChatOpen,
        setMobileChatOpen
    ] = useState(false);


    // ========================================================
    // MENSAGENS
    // ========================================================

    const [
        messages,
        setMessages
    ] = useState([]);

    const [
        messageText,
        setMessageText
    ] = useState("");


    // ========================================================
    // LOADING
    // ========================================================

    const [
        loadingConversations,
        setLoadingConversations
    ] = useState(false);

    const [
        loadingMessages,
        setLoadingMessages
    ] = useState(false);

    const [
        sendingMessage,
        setSendingMessage
    ] = useState(false);

    const [
        actionLoading,
        setActionLoading
    ] = useState(false);


    // ========================================================
    // ERROR
    // ========================================================

    const [
        error,
        setError
    ] = useState("");


    // ========================================================
    // REF
    // ========================================================

    const messagesContainerRef =
        useRef(null);


    // ========================================================
    // OPERADOR
    // ========================================================

    const operatorId =
        operator?.id || null;


    // ========================================================
    // SCROLL
    // ========================================================

    const isMessagesNearBottom =
        useCallback(() => {

            const container =
                messagesContainerRef.current;

            if (!container) {
                return true;
            }

            const distanceFromBottom =
                container.scrollHeight -
                container.scrollTop -
                container.clientHeight;

            return distanceFromBottom <= 100;

        }, []);


    const scrollToBottom =
        useCallback(
            (
                smooth = true
            ) => {

                setTimeout(() => {

                    const container =
                        messagesContainerRef.current;

                    if (!container) {
                        return;
                    }

                    container.scrollTo({

                        top:
                            container.scrollHeight,

                        behavior:
                            smooth
                                ? "smooth"
                                : "auto"

                    });

                }, 50);

            },
            []
        );


    // ========================================================
    // CARREGAR CONVERSAS
    // ========================================================

    const loadConversations =
        useCallback(
            async (
                keepSelection = true
            ) => {

                try {

                    setLoadingConversations(
                        true
                    );

                    setError("");


                    const response =
                        await getConversations({

                            mode:
                                mode,

                            status:
                                status,

                            state:
                                state

                        });


                    if (
                        response &&
                        response.success
                    ) {

                        const list =
                            response.conversations ||
                            [];


                        setConversations(
                            list
                        );


                        // ------------------------------------
                        // MANTER SELEÇÃO
                        // ------------------------------------

                        if (
                            keepSelection &&
                            selectedConversation
                        ) {

                            const updated =
                                list.find(
                                    conversation =>
                                        Number(
                                            conversation.id
                                        ) ===
                                        Number(
                                            selectedConversation.id
                                        )
                                );


                            if (updated) {

                                setSelectedConversation(
                                    previous => ({

                                        ...updated,

                                        unread_count:
                                            0,

                                        contact_name:
                                            updated.contact_name ||
                                            previous?.contact_name,

                                        profile_pic_url:
                                            updated.profile_pic_url ||
                                            previous?.profile_pic_url,

                                        profile_picture_url:
                                            updated.profile_picture_url ||
                                            previous?.profile_picture_url

                                    })
                                );

                            } else {

                                setSelectedConversation(
                                    null
                                );

                                setMessages([]);

                                setMobileChatOpen(
                                    false
                                );

                            }

                        }

                    } else {

                        setConversations([]);

                    }

                } catch (err) {

                    console.error(
                        "Erro ao carregar conversas:",
                        err
                    );

                    setError(
                        err.message ||
                        "Não foi possível carregar as conversas."
                    );

                } finally {

                    setLoadingConversations(
                        false
                    );

                }

            },
            [
                mode,
                status,
                state,
                selectedConversation
            ]
        );


    // ========================================================
    // CARREGAR MENSAGENS
    // ========================================================

    const loadMessages =
        useCallback(
            async (
                conversationId,
                silent = false
            ) => {

                if (!conversationId) {
                    return;
                }


                try {

                    if (!silent) {

                        setLoadingMessages(
                            true
                        );

                    }


                    const shouldKeepBottom =
                        isMessagesNearBottom();


                    const response =
                        await getMessages(
                            conversationId
                        );


                    if (
                        response &&
                        response.success
                    ) {

                        const newMessages =
                            response.messages ||
                            [];


                        setMessages(
                            newMessages
                        );


                        if (!silent) {

                            scrollToBottom(
                                false
                            );

                        } else if (
                            shouldKeepBottom
                        ) {

                            scrollToBottom(
                                false
                            );

                        }

                    }

                } catch (err) {

                    console.error(
                        "Erro ao carregar mensagens:",
                        err
                    );


                    if (!silent) {

                        setError(
                            err.message ||
                            "Não foi possível carregar as mensagens."
                        );

                    }

                } finally {

                    if (!silent) {

                        setLoadingMessages(
                            false
                        );

                    }

                }

            },
            [
                isMessagesNearBottom,
                scrollToBottom
            ]
        );


    // ========================================================
    // PRIMEIRA CARGA
    // ========================================================

    useEffect(() => {

        loadConversations(
            false
        );

    }, [
        mode,
        status,
        state
    ]);

    useEffect(() => {

        const loadDepartments = async () => {

            try {

                const response =
                    await getDepartments();

                if (
                    response &&
                    response.success
                ) {

                    setDepartments(
                        response.departments || []
                    );

                } else {

                    setDepartments([]);

                }

            } catch (err) {

                console.error(
                    "Erro ao carregar departamentos:",
                    err
                );

                setDepartments([]);

            }

        };

        loadDepartments();

    }, []);

    useEffect(() => {

        const socket = io(
            "https://omnichannel.multsite.com.br",
            {
                transports: [
                    "websocket"
                ]
            }
        );


        socket.on(
            "connect",
            () => {

                console.log(
                    "Socket conectado:",
                    socket.id
                );

            }
        );


        socket.on(
            "connect_error",
            error => {

                console.error(
                    "Erro Socket.IO:",
                    error
                );

            }
        );


        socket.on(
            "new_message",
            data => {

                console.log(
                    "Nova mensagem realtime:",
                    data
                );


                // ====================================================
                // ATUALIZA LISTA LOCALMENTE
                // ====================================================

                setConversations(
                    previous => {

                        const updated =
                            previous.map(
                                conversation => {


                                    if (
                                        String(
                                            conversation.remote_jid
                                        ) ===
                                        String(
                                            data.remote_jid
                                        )
                                    ) {

                                        return {

                                            ...conversation,


                                            last_message:
                                                data.message ||
                                                conversation.last_message,


                                            last_message_at:
                                                data.created_at ||
                                                new Date().toISOString(),


                                            unread_count:
                                                selectedConversation &&
                                                    String(
                                                        selectedConversation.remote_jid
                                                    ) ===
                                                    String(
                                                        data.remote_jid
                                                    )
                                                    ? 0
                                                    :
                                                    Number(
                                                        conversation.unread_count || 0
                                                    ) + 1

                                        };

                                    }


                                    return conversation;

                                }
                            );


                        return updated.sort(
                            (a, b) =>
                                new Date(
                                    b.last_message_at
                                ) -
                                new Date(
                                    a.last_message_at
                                )
                        );

                    }
                );


                // ====================================================
                // ATUALIZA CHAT ABERTO
                // ====================================================

                if (
                    selectedConversation
                ) {

                    const sameConversation =
                        String(
                            selectedConversation.remote_jid
                        ) ===
                        String(
                            data.remote_jid
                        );


                    if (
                        sameConversation
                    ) {

                        loadMessages(
                            selectedConversation.id,
                            true
                        );

                    }

                }

            }
        );


        socket.on(
            "disconnect",
            reason => {

                console.log(
                    "Socket desconectado:",
                    reason
                );

            }
        );


        return () => {

            socket.disconnect();

        };


    }, [
        loadConversations,
        loadMessages,
        selectedConversation
    ]);

    // ========================================================
    // MARCAR COMO LIDA
    // ========================================================

    const handleMarkAsRead =
        async conversationId => {

            try {

                await markConversationAsRead(
                    conversationId
                );

            } catch (err) {

                console.error(
                    "Erro ao marcar conversa como lida:",
                    err
                );

            }

        };


    // ========================================================
    // SELECIONAR CONVERSA
    // ========================================================

    const handleSelectConversation =
        async conversation => {

            const selected = {

                ...conversation,

                unread_count:
                    0

            };


            setSelectedConversation(
                selected
            );


            setMessages([]);

            setError("");


            // ----------------------------------------------
            // MOBILE
            // ----------------------------------------------

            setMobileChatOpen(
                true
            );


            await handleMarkAsRead(
                conversation.id
            );


            setConversations(
                previous =>
                    previous.map(
                        item =>
                            Number(
                                item.id
                            ) ===
                                Number(
                                    conversation.id
                                )
                                ? {

                                    ...item,

                                    unread_count:
                                        0

                                }
                                : item
                    )
            );


            await loadMessages(
                conversation.id
            );

        };


    // ========================================================
    // VOLTAR PARA LISTA NO MOBILE
    // ========================================================

    const handleBackToConversations =
        () => {

            setMobileChatOpen(
                false
            );

        };


    // ========================================================
    // ENVIAR MENSAGEM
    // ========================================================

    const handleSendMessage =
        async () => {

            if (!selectedConversation) {
                return;
            }


            const text =
                messageText.trim();


            if (!text) {
                return;
            }


            if (!operatorId) {

                setError(
                    "Operador não identificado."
                );

                return;

            }


            try {

                setSendingMessage(
                    true
                );

                setError("");


                const response =
                    await sendMessage({

                        conversationId:
                            selectedConversation.id,

                        text

                    });


                if (
                    response &&
                    response.success
                ) {

                    setMessageText("");


                    await loadMessages(
                        selectedConversation.id
                    );


                    await loadConversations(
                        true
                    );

                } else {

                    setError(
                        response?.message ||
                        "Não foi possível enviar a mensagem."
                    );

                }

            } catch (err) {

                console.error(
                    "Erro ao enviar mensagem:",
                    err
                );


                setError(
                    err.message ||
                    "Erro ao enviar mensagem."
                );

            } finally {

                setSendingMessage(
                    false
                );

            }

        };


    // ========================================================
    // ASSUMIR ATENDIMENTO
    // ========================================================

    const handleAssignConversation =
        async () => {

            if (
                !selectedConversation ||
                !operatorId
            ) {
                return;
            }


            try {

                setActionLoading(
                    true
                );

                setError("");


                const response =
                    await assignConversation(
                        selectedConversation.id,
                        operatorId
                    );


                if (
                    response &&
                    response.success
                ) {

                    setSelectedConversation(
                        previous => ({

                            ...previous,

                            mode:
                                "HUMAN",

                            status:
                                "OPEN"

                        })
                    );


                    await loadConversations(
                        true
                    );

                } else {

                    setError(
                        response?.message ||
                        "Não foi possível assumir o atendimento."
                    );

                }

            } catch (err) {

                console.error(
                    "Erro ao assumir atendimento:",
                    err
                );


                setError(
                    err.message ||
                    "Erro ao assumir atendimento."
                );

            } finally {

                setActionLoading(
                    false
                );

            }

        };


    // ========================================================
    // VOLTAR PARA BOT
    // ========================================================

    const handleReturnToBot =
        async () => {

            if (!selectedConversation) {
                return;
            }


            try {

                setActionLoading(
                    true
                );

                setError("");


                const response =
                    await returnToBot(
                        selectedConversation.id
                    );


                if (
                    response &&
                    response.success
                ) {

                    setSelectedConversation(
                        previous => ({

                            ...previous,

                            mode:
                                "BOT",

                            status:
                                "OPEN"

                        })
                    );


                    await loadConversations(
                        true
                    );


                    await loadMessages(
                        selectedConversation.id,
                        true
                    );

                } else {

                    setError(
                        response?.message ||
                        "Não foi possível retornar a conversa para o bot."
                    );

                }

            } catch (err) {

                console.error(
                    "Erro ao retornar para bot:",
                    err
                );


                setError(
                    err.message ||
                    "Erro ao retornar para bot."
                );

            } finally {

                setActionLoading(
                    false
                );

            }

        };


    // ========================================================
    // ENCERRAR ATENDIMENTO
    // ========================================================

    const handleCloseConversation = async () => {

        if (!selectedConversation) {
            return;
        }

        try {

            setActionLoading(true);
            setError("");

            const conversationId = selectedConversation.id;

            const response = await closeConversation(
                conversationId
            );

            if (
                response &&
                response.success
            ) {

                // Remove imediatamente da lista
                setConversations(previous =>
                    previous.filter(
                        conversation =>
                            Number(conversation.id) !==
                            Number(conversationId)
                    )
                );

                // Fecha o atendimento visualmente
                setSelectedConversation(null);

                // Limpa as mensagens
                setMessages([]);

                // Fecha o chat no mobile
                setMobileChatOpen(false);

                // Garante que a lista continue sendo somente OPEN
                await loadConversations(false);

            } else {

                setError(
                    response?.message ||
                    "Não foi possível encerrar o atendimento."
                );

            }

        } catch (err) {

            console.error(
                "Erro ao encerrar atendimento:",
                err
            );

            setError(
                err.message ||
                "Erro ao encerrar atendimento."
            );

        } finally {

            setActionLoading(false);

        }

    };

    const handleReopenConversation = async () => {

        if (!selectedConversation) {
            return;
        }

        try {

            setActionLoading(true);
            setError("");

            const conversationId =
                selectedConversation.id;

            const response =
                await reopenConversation(
                    conversationId
                );

            if (
                response &&
                response.success
            ) {

                // Atualiza a conversa para OPEN
                setSelectedConversation(
                    previous => ({
                        ...previous,
                        status: "OPEN"
                    })
                );

                // Como o painel lista somente OPEN,
                // coloca a conversa novamente na lista
                await loadConversations(false);

            } else {

                setError(
                    response?.message ||
                    "Não foi possível reabrir a conversa."
                );

            }

        } catch (err) {

            console.error(
                "Erro ao reabrir conversa:",
                err
            );

            setError(
                err.message ||
                "Erro ao reabrir conversa."
            );

        } finally {

            setActionLoading(false);

        }

    };


    // ========================================================
    // ENTER
    // ========================================================

    const handleMessageKeyDown =
        event => {

            if (
                event.key === "Enter" &&
                !event.shiftKey
            ) {

                event.preventDefault();

                handleSendMessage();

            }

        };


    // ========================================================
    // FORMATA DATA
    // ========================================================

    const formatDate =
        value => {

            if (!value) {
                return "";
            }


            const date =
                new Date(value);


            if (
                Number.isNaN(
                    date.getTime()
                )
            ) {

                return "";

            }


            return date.toLocaleTimeString(
                "pt-BR",
                {
                    hour:
                        "2-digit",

                    minute:
                        "2-digit"
                }
            );

        };

    // ========================================================
    // MEDIA MESSAGE
    // ========================================================

    const MEDIA_URL =
        "https://omnichannel.multsite.com.br/";


    const getMediaUrl = (
        msg
    ) => {

        if (
            !msg ||
            !msg.media_path
        ) {
            return "";
        }


        return `${MEDIA_URL}/media/${msg.media_path}`;

    };


    // ========================================================
    // MEDIA COMPONENT
    // ========================================================

    const MessageMedia = ({
        msg
    }) => {


        if (
            !msg ||
            !msg.media_type
        ) {

            return msg.message;

        }


        const url =
            getMediaUrl(
                msg
            );


        if (!url) {

            return msg.message;

        }



        switch (
        msg.media_type
        ) {


            case "image":

                return (

                    <div className="message-media">

                        <img
                            src={url}
                            alt={
                                msg.media_filename ||
                                "Imagem recebida"
                            }
                            className="message-image"
                            onClick={() =>
                                setImagePreview(url)
                            }
                            loading="lazy"
                        />

                    </div>

                );



            case "audio":

                return (

                    <audio

                        controls

                        className="message-audio"

                    >

                        <source

                            src={url}

                            type={
                                msg.media_mimetype
                            }

                        />

                        Seu navegador não suporta áudio.

                    </audio>

                );



            case "video":

                return (

                    <video

                        controls

                        className="message-video"

                    >

                        <source

                            src={url}

                            type={
                                msg.media_mimetype
                            }

                        />

                        Seu navegador não suporta vídeo.

                    </video>

                );



            case "document":

                return (

                    <a

                        href={url}

                        target="_blank"

                        rel="noreferrer"

                        className="message-document"

                    >

                        📄

                        {
                            msg.media_filename ||
                            "Abrir documento"
                        }

                    </a>

                );



            default:

                return (

                    <a

                        href={url}

                        target="_blank"

                        rel="noreferrer"

                    >

                        Abrir arquivo

                    </a>

                );

        }

    };

    // ========================================================
    // FOTO
    // ========================================================

    const getProfilePicture =
        conversation => {

            if (!conversation) {
                return "";
            }


            const picture =
                conversation.profile_pic_url ||
                conversation.profile_picture_url ||
                conversation.profilePictureUrl ||
                conversation.profile_picture ||
                conversation.profilePicture ||
                conversation.profilePictureURL ||
                conversation.picture ||
                conversation.avatar ||
                conversation.avatar_url ||
                "";


            if (
                typeof picture !== "string"
            ) {

                return "";

            }


            return picture.trim();

        };


    // ========================================================
    // NÚMERO
    // ========================================================

    const getContactNumber =
        conversation => {

            if (!conversation) {
                return "";
            }


            if (
                conversation.remote_jid
            ) {

                return conversation.remote_jid
                    .replace(
                        "@s.whatsapp.net",
                        ""
                    )
                    .replace(
                        "@c.us",
                        ""
                    )
                    .replace(
                        /\D/g,
                        ""
                    );

            }


            return "";

        };


    // ========================================================
    // FORMATAR TELEFONE
    // ========================================================

    const formatPhone =
        phone => {

            if (!phone) {
                return "";
            }


            const numbers =
                String(phone).replace(
                    /\D/g,
                    ""
                );


            // ----------------------------------------------
            // Brasil +55 + DDD + 9 dígitos
            // ----------------------------------------------

            if (
                numbers.length === 13 &&
                numbers.startsWith("55")
            ) {

                const ddd =
                    numbers.substring(
                        2,
                        4
                    );

                const first =
                    numbers.substring(
                        4,
                        5
                    );

                const middle =
                    numbers.substring(
                        5,
                        9
                    );

                const last =
                    numbers.substring(
                        9,
                        13
                    );


                return `(${ddd}) ${first}-${middle}-${last}`;

            }


            // ----------------------------------------------
            // Brasil +55 + DDD + 8 dígitos
            // ----------------------------------------------

            if (
                numbers.length === 12 &&
                numbers.startsWith("55")
            ) {

                const ddd =
                    numbers.substring(
                        2,
                        4
                    );

                const first =
                    numbers.substring(
                        4,
                        8
                    );

                const last =
                    numbers.substring(
                        8,
                        12
                    );


                return `(${ddd}) ${first}-${last}`;

            }


            // ----------------------------------------------
            // DDD + 9 dígitos
            // ----------------------------------------------

            if (
                numbers.length === 11
            ) {

                const ddd =
                    numbers.substring(
                        0,
                        2
                    );

                const first =
                    numbers.substring(
                        2,
                        3
                    );

                const middle =
                    numbers.substring(
                        3,
                        7
                    );

                const last =
                    numbers.substring(
                        7,
                        11
                    );


                return `(${ddd}) ${first}-${middle}-${last}`;

            }


            // ----------------------------------------------
            // DDD + 8 dígitos
            // ----------------------------------------------

            if (
                numbers.length === 10
            ) {

                const ddd =
                    numbers.substring(
                        0,
                        2
                    );

                const first =
                    numbers.substring(
                        2,
                        6
                    );

                const last =
                    numbers.substring(
                        6,
                        10
                    );


                return `(${ddd}) ${first}-${last}`;

            }


            return numbers;

        };


    // ========================================================
    // NOME + TELEFONE
    // ========================================================

    const getContactName =
        conversation => {

            if (!conversation) {
                return "Contato";
            }

            const number =
                getContactNumber(
                    conversation
                );


            const formattedNumber =
                formatPhone(
                    number
                );

            // ----------------------------------------------
            // telefone
            // ----------------------------------------------

            if (formattedNumber) {
                return `${formattedNumber}`;
            }

            return "Contato";

        };


    // ========================================================
    // INICIAL
    // ========================================================

    const getInitial =
        conversation => {

            const name =
                getContactName(
                    conversation
                );


            return (
                name
                    .charAt(0)
                    .toUpperCase() ||
                "?"
            );

        };


    // ========================================================
    // AVATAR
    // ========================================================

    const Avatar = ({
        conversation,
        large = false
    }) => {

        const picture =
            getProfilePicture(
                conversation
            );


        const [
            imageError,
            setImageError
        ] = useState(false);


        useEffect(() => {

            setImageError(
                false
            );

        }, [
            picture
        ]);


        if (
            picture &&
            !imageError
        ) {

            return (

                <div
                    className={
                        `avatar ${large
                            ? "large"
                            : ""
                        }`
                    }
                >

                    <img
                        src={picture}
                        alt={
                            getContactName(
                                conversation
                            )
                        }
                        loading="lazy"
                        referrerPolicy="no-referrer"
                        onError={() =>
                            setImageError(
                                true
                            )
                        }
                    />

                </div>

            );

        }


        return (

            <div
                className={
                    `avatar ${large
                        ? "large"
                        : ""
                    }`
                }
            >

                {
                    getInitial(
                        conversation
                    )
                }

            </div>

        );

    };

    const [imagePreview, setImagePreview] = useState(null);

    // ========================================================
    // FILTRAR CONVERSAS POR DEPARTAMENTO
    // ========================================================

    const filteredConversations =
        conversations.filter(
            conversation => {

                if (!departmentId) {
                    return true;
                }

                return Number(
                    conversation.department_id
                ) === Number(
                    departmentId
                );

            }
        );



    // ========================================================
    // RENDER
    // ========================================================

    return (

        <div
            className={
                `omnichannel ${mobileChatOpen
                    ? "mobile-chat-open"
                    : ""
                }`
            }
        >

            {
                imagePreview && (

                    <div
                        className="image-modal"
                        onClick={() =>
                            setImagePreview(null)
                        }
                    >

                        <button
                            className="image-close"
                            onClick={(e) => {

                                e.stopPropagation();

                                setImagePreview(null);

                            }}
                        >
                            ×
                        </button>


                        <img
                            src={imagePreview}
                            className="image-preview"
                            onClick={(e) =>
                                e.stopPropagation()
                            }
                        />

                    </div>

                )
            }

            {/* ==================================================
                SIDEBAR
            ================================================== */}

            <aside className="sidebar">

                <div className="sidebar-header">

                    <div>

                        <h1>
                            ChatBot
                        </h1>

                        <span>
                            MultSite
                        </span>

                    </div>


                    <div className="sidebar-header-actions">

                        <button
                            className="refresh-button"
                            onClick={() =>
                                loadConversations(
                                    true
                                )
                            }
                            title="Atualizar"
                        >
                            ↻
                        </button>


                        <button
                            className="refresh-button"
                            onClick={logout}
                            title="Sair"
                        >
                            Sair
                        </button>

                    </div>

                </div>


                {/* OPERADOR */}

                {
                    operator && (

                        <div className="operator-name">

                            Operador: {operator.name}

                        </div>

                    )
                }


                {/* FILTROS */}

                <div className="filters">

                    <div className="filter-group">

                        <label>
                            Atendimento
                        </label>


                        <select
                            className="filter-select"
                            value={mode}
                            onChange={event =>
                                setMode(
                                    event.target.value
                                )
                            }
                        >

                            <option value="">
                                Todos
                            </option>

                            <option value="HUMAN">
                                Humano
                            </option>

                            <option value="BOT">
                                Bot
                            </option>

                        </select>

                    </div>


                    <div className="filter-group">

                        <label>
                            Status
                        </label>


                        <select
                            className="filter-select"
                            value={status}
                            onChange={event =>
                                setStatus(
                                    event.target.value
                                )
                            }
                        >

                            <option value="">
                                Todos
                            </option>

                            <option value="OPEN">
                                Abertas
                            </option>

                            <option value="CLOSED">
                                Encerradas
                            </option>

                        </select>

                    </div>

                    <div className="filter-group">

                        <label>
                            Departamento
                        </label>

                        <select
                            className="filter-select"
                            value={departmentId}
                            onChange={event =>
                                setDepartmentId(
                                    event.target.value
                                )
                            }
                        >

                            <option value="">
                                Todos
                            </option>

                            {
                                departments.map(
                                    department => (

                                        <option
                                            key={department.id}
                                            value={department.id}
                                        >
                                            {department.name}
                                        </option>

                                    )
                                )
                            }

                        </select>

                    </div>

                </div>


                {/* CONTADOR */}

                <div className="conversation-count">

                    <span>
                        Conversas
                    </span>


                    <strong>

                        {
                            loadingConversations
                                ? "..."
                                : filteredConversations.length
                        }

                    </strong>

                </div>


                {/* LISTA */}

                <div className="conversation-list">

                    {
                        loadingConversations &&
                            filteredConversations.length === 0

                            ? (

                                <div className="empty-state">

                                    Carregando...

                                </div>

                            )

                            : filteredConversations.length === 0

                                ? (

                                    <div className="empty-state">

                                        <div className="empty-icon">
                                            💬
                                        </div>


                                        <strong>
                                            Nenhuma conversa
                                        </strong>


                                        <span>
                                            Não existem conversas
                                            para os filtros atuais.
                                        </span>

                                    </div>

                                )

                                : (

                                    filteredConversations.map(
                                        conversation => {

                                            const active =
                                                selectedConversation &&
                                                Number(
                                                    selectedConversation.id
                                                ) ===
                                                Number(
                                                    conversation.id
                                                );


                                            return (

                                                <button
                                                    key={
                                                        conversation.id
                                                    }
                                                    className={
                                                        `conversation-item ${active
                                                            ? "active"
                                                            : ""
                                                        }`
                                                    }
                                                    onClick={() =>
                                                        handleSelectConversation(
                                                            conversation
                                                        )
                                                    }
                                                >

                                                    <Avatar
                                                        conversation={
                                                            conversation
                                                        }
                                                    />


                                                    <div className="conversation-info">

                                                        <div className="conversation-top">

                                                            <strong>
                                                                {
                                                                    getContactName(
                                                                        conversation
                                                                    )
                                                                }
                                                            </strong>


                                                            <span>
                                                                {
                                                                    formatDate(
                                                                        conversation.last_message_at
                                                                    )
                                                                }
                                                            </span>

                                                        </div>


                                                        <div className="conversation-bottom">

                                                            <span className="last-message">

                                                                {
                                                                    conversation.last_message ||
                                                                    "Nenhuma mensagem"
                                                                }

                                                            </span>


                                                            {
                                                                Number(
                                                                    conversation.unread_count
                                                                ) > 0 && (

                                                                    <span className="unread">

                                                                        {
                                                                            conversation.unread_count
                                                                        }

                                                                    </span>

                                                                )
                                                            }

                                                        </div>

                                                    </div>

                                                </button>

                                            );

                                        }
                                    )

                                )
                    }

                </div>

            </aside>


            {/* ==================================================
                CHAT
            ================================================== */}

            <main className="chat">

                {
                    !selectedConversation

                        ? (

                            <div className="chat-empty">

                                <div className="chat-empty-content">

                                    <div className="chat-empty-icon">
                                        💬
                                    </div>

                                    <h2>
                                        Selecione uma conversa
                                    </h2>

                                    <p>
                                        Escolha uma conversa ao lado para iniciar o atendimento.
                                    </p>

                                </div>

                            </div>

                        )

                        : (

                            <>

                                {/* HEADER */}

                                <header className="chat-header">

                                    <div className="chat-contact">

                                        {/* VOLTAR MOBILE */}

                                        <button
                                            className="mobile-back-button"
                                            onClick={
                                                handleBackToConversations
                                            }
                                            aria-label="Voltar"
                                        >
                                            ←
                                        </button>


                                        <Avatar
                                            conversation={
                                                selectedConversation
                                            }
                                            large
                                        />


                                        <div className="chat-contact-info">

                                            <h2>
                                                {
                                                    getContactName(
                                                        selectedConversation
                                                    )
                                                }
                                            </h2>


                                            <div className="contact-details">

                                                <span>
                                                    {
                                                        selectedConversation.remote_jid
                                                            ?.replace(
                                                                "@s.whatsapp.net",
                                                                ""
                                                            )
                                                            .replace(
                                                                "@c.us",
                                                                ""
                                                            )
                                                    }
                                                </span>


                                                <span>
                                                    •
                                                </span>


                                                <span>
                                                    {
                                                        selectedConversation.instance
                                                    }
                                                </span>

                                            </div>

                                        </div>

                                    </div>


                                    {/* AÇÕES */}

                                    <div className="chat-actions">

                                        {
                                            selectedConversation.status === "CLOSED" ? (

                                                <button
                                                    className="action-button take-action"
                                                    onClick={handleReopenConversation}
                                                    disabled={actionLoading}
                                                >

                                                    <span>
                                                        ↻
                                                    </span>

                                                    <span className="action-label">
                                                        Reabrir conversa
                                                    </span>

                                                </button>

                                            ) : (

                                                <>
                                                    {
                                                        selectedConversation.mode === "HUMAN"
                                                            ? (

                                                                <button
                                                                    className="action-button bot-action"
                                                                    onClick={handleReturnToBot}
                                                                    disabled={actionLoading}
                                                                >
                                                                    <span>↩</span>

                                                                    <span className="action-label">
                                                                        Voltar para bot
                                                                    </span>
                                                                </button>

                                                            )
                                                            : (

                                                                <button
                                                                    className="action-button take-action"
                                                                    onClick={handleAssignConversation}
                                                                    disabled={actionLoading}
                                                                >
                                                                    <span>✓</span>

                                                                    <span className="action-label">
                                                                        Assumir atendimento
                                                                    </span>
                                                                </button>

                                                            )
                                                    }

                                                    <button
                                                        className="action-button close-action"
                                                        onClick={handleCloseConversation}
                                                        disabled={actionLoading}
                                                    >
                                                        <span>×</span>

                                                        <span className="action-label">
                                                            Encerrar
                                                        </span>
                                                    </button>
                                                </>

                                            )
                                        }

                                    </div>

                                </header>


                                {/* MENSAGENS */}

                                <section
                                    className="messages"
                                    ref={
                                        messagesContainerRef
                                    }
                                >

                                    {
                                        loadingMessages

                                            ? (

                                                <div className="messages-loading">

                                                    Carregando mensagens...

                                                </div>

                                            )

                                            : messages.length === 0

                                                ? (

                                                    <div className="messages-loading">

                                                        Nenhuma mensagem.

                                                    </div>

                                                )

                                                : (

                                                    messages.map(
                                                        msg => {

                                                            console.log(
                                                                "MESSAGE RECEBIDA:",
                                                                msg
                                                            );

                                                            const isOperator =
                                                                msg.role ===
                                                                "operator";


                                                            const isAssistant =
                                                                msg.role ===
                                                                "assistant";


                                                            return (

                                                                <div
                                                                    key={
                                                                        msg.id
                                                                    }
                                                                    className={
                                                                        `message-row ${isOperator
                                                                            ? "operator"
                                                                            : isAssistant
                                                                                ? "assistant"
                                                                                : "user"
                                                                        }`
                                                                    }
                                                                >

                                                                    <div className="message-bubble">

                                                                        <div className="message-text">

                                                                            {
                                                                                msg.media_type
                                                                                    ? (
                                                                                        <MessageMedia
                                                                                            msg={msg}
                                                                                        />
                                                                                    )
                                                                                    : (
                                                                                        <MessageList
                                                                                            message={msg.message}
                                                                                        />
                                                                                    )
                                                                            }

                                                                        </div>

                                                                        <div className="message-footer">

                                                                            <span>

                                                                                {
                                                                                    msg.role ===
                                                                                        "operator"
                                                                                        ? "Operador"
                                                                                        : msg.role ===
                                                                                            "assistant"
                                                                                            ? "Bot"
                                                                                            : "Cliente"
                                                                                }

                                                                            </span>


                                                                            <span>

                                                                                {
                                                                                    formatDate(
                                                                                        msg.created_at
                                                                                    )
                                                                                }

                                                                            </span>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            );

                                                        }
                                                    )

                                                )
                                    }

                                </section>


                                {/* COMPOSER */}

                                <footer className="composer">

                                    {
                                        error && (

                                            <div className="error-message">

                                                {error}

                                            </div>

                                        )
                                    }


                                    {
                                        selectedConversation.mode !==
                                        "HUMAN" &&
                                        selectedConversation.status !==
                                        "CLOSED" && (

                                            <div className="bot-warning">

                                                Esta conversa está sendo
                                                atendida pelo bot.

                                                <span>

                                                    Ao enviar uma mensagem,
                                                    ela será automaticamente
                                                    colocada no modo manual.

                                                </span>

                                            </div>

                                        )
                                    }


                                    {
                                        selectedConversation.status ===
                                        "CLOSED" && (

                                            <div className="closed-warning">

                                                Esta conversa está encerrada.

                                            </div>

                                        )
                                    }


                                    <div className="composer-row">

                                        <textarea
                                            value={
                                                messageText
                                            }
                                            onChange={event =>
                                                setMessageText(
                                                    event.target.value
                                                )
                                            }
                                            onKeyDown={
                                                handleMessageKeyDown
                                            }
                                            placeholder="Digite uma mensagem..."
                                            disabled={
                                                sendingMessage
                                            }
                                            rows={1}
                                        />


                                        <button
                                            onClick={
                                                handleSendMessage
                                            }
                                            disabled={
                                                sendingMessage ||
                                                !messageText.trim()
                                            }
                                        >

                                            {
                                                sendingMessage
                                                    ? "..."
                                                    : "➤"
                                            }

                                        </button>

                                    </div>

                                </footer>

                            </>

                        )
                }

            </main>

        </div>

    );

}

export default App;
